import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { toast } from 'react-toastify';
import moment from 'moment';
import { GFU } from '~/constants/perfil';

import { isNull, isArray, concat, trim, isUndefined } from 'lodash';


import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  Input,
  RadioGroup,
  Select,
} from '~/components/Form';

import api from '~/services/api';
import qs from 'querystring';

import * as Yup from 'yup';
import { t } from '~/helpers';

function Relabastecimentonoperiodovalor() {
  const [open, setOpen] = useState(true);

  //NOVOS CAMPOS
  const [valueOrgao, setValueOrgao] = React.useState(0);
  const [inputValueOrgao, setInputValueOrgao] = React.useState('');

  const [orgaNome, setOrgaNome] = React.useState('');

  const [valueUnidade, setValueUnidade] = React.useState(0);
  const [inputValueUnidade, setInputValueUnidade] = React.useState('');
  const [disableUnidade, setDisableUnidade] = useState(false)
  const [defaultUnidade, setDefaultUnidade] = useState('')

  const [valueProduto, setValueProduto] = React.useState(0);
  const [inputValueProduto, setInputValueProduto] = React.useState('');

  async function handleValidate(param) {
    try {
      const schema = Yup.object().shape({
        datahorainicial: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        datahorafinal: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        veic_placa: Yup.string()
          .nullable()
          .max(7, t('s.geral.validacao.tamanhomaximo').replace('%s', 7)),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const { datahorainicial, datahorafinal } = param;
      if (!moment(datahorafinal, 'DD/MM/YYYY HH:mm:ss').isAfter(moment(datahorainicial, 'DD/MM/YYYY HH:mm:ss'))) {
        throw t("A data final tem que ser maior do que a data inicial");
      }

      if (disableUnidade && !defaultUnidade.unid_codigo) {
        throw ('Este usuário não possui unidade(s) cadastrada(s) !')
      }
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      } else {
        throw err
      }
    }
  }

  const handleGetUnidades = useCallback(async () => {
    try {

      const { data } = await api.get('unidades/usuario', {
        params: {
          wherefield: 'orga_codigo',
          valuewherefield: valueOrgao,
          typewherefield: 'EQUALS',
          pagezie: 99999
        },
        paramsSerializer: (param) => qs.stringify(param)
      });

      console.log(data)

      if (data.items.length == 1) {
        let unidade = data.items[0]
        setDefaultUnidade(unidade)
        setValueUnidade(unidade.unid_codigo)
        setInputValueUnidade(unidade.unid_nome)
        setDisableUnidade(true)
      } else if (data.items.length == 0) {
        setDefaultUnidade({ unid_codigo: '', unid_nome: '' })
        setValueUnidade('')
        setInputValueUnidade('')
        setDisableUnidade(true)
      } else {
        setDisableUnidade(false)
      }


    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [inputValueOrgao])


  const [disableOrgao, setDisableOrgao] = useState(false);
  const [unidadeUsuario, setUnidadeUsuario] = useState(false);

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });

  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  const { profile } = useSelector((state) => state.user);


  useEffect(() => {
    handleGetUnidades();

  }, [inputValueOrgao])

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      if (profile.glousuariotipo === GFU) {
        setValueOrgao(profile.glousuarioorgacodigo);
        setOrgaNome(profile.glousuarioorganome);
        setDisableOrgao(true);
        setUnidadeUsuario(true);
        handleGetUnidades();
      }
    }

    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  function handleSerializeForm(params) {
    const { datahorainicial, datahorafinal } = params;

    let orgao = '0';

    if (params.orga_codigo) {
      orgao = params.orga_codigo;
    }

    let orgaostr = '';

    if (orgaNome) {
      orgaostr = orgaNome;
    } else {
      if (params.orga_nome) {
        orgaostr = params.orga_nome;
      }
    }

    let unidade = '0';

    if (params.unid_codigo) {
      unidade = params.unid_codigo;
    }

    let unidadestr = '';

    if (params.unid_nome) {

      unidadestr = params.unid_nome;


    }
    if (disableUnidade) {
      unidadestr = defaultUnidade.unid_nome
    }

    let produto = '';

    if (params.prod_codigo) {
      produto = params.prod_codigo;
    }

    let produtostr = '';

    if (params.prod_descricao) {
      produtostr = params.prod_descricao;
    }

    let agrupamento = '1';

    if (params.abastecimentoagrupamento) {
      agrupamento = params.abastecimentoagrupamento;
    }

    let placa = '';

    if (params.veic_placa) {
      placa = params.veic_placa;
    }

    let tipo = 'pdf';

    if (params.formato) {
      tipo = params.formato;
    }

    return {
      ...params,
      unidade,
      unidadestr,
      orgao,
      orgaostr,
      produto,
      produtostr,
      agrupamento,
      placa,
      tipo,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title="Abastecimento da Unidade no Período - Valor"
      relatorio="abastecimentosunidadeperiodovalor"
      validate={(param) => handleValidate(param)}
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
        orga_codigo: valueOrgao,
      }}
    >
      <DateTime
        label="Data Inicial"
        name="datahorainicial"
        serialize={(value) =>
          value.set({ second: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <DateTime
        label="Data Final"
        name="datahorafinal"
        serialize={(value) =>
          value.set({ second: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <Autocomplete
        name="orga_codigo"
        label="orga_nome"
        title="Órgão"
        id="orga_codigo"
        url="orgaos"
        unique="orga_codigo"
        value={valueOrgao}
        inputValue={inputValueOrgao}
        onChange={(event, newValue) => {
          setValueOrgao(newValue);
        }}
        onInputChange={(event, newInputValueOrgao) => {
          setInputValueOrgao(newInputValueOrgao);
        }}
        defaultValue=""
        hiddens={[{ name: 'orga_nome' }]}
        getValue={(value) => {
          setValueUnidade(0);
          setInputValueUnidade('');
          if (value.orga_codigo !== null) {
            setValueOrgao(value.orga_codigo);
          } else {
            setValueOrgao(0);
          }
        }}
        disabled={disableOrgao}
      />

      <Autocomplete
        name="unid_codigo"
        label="unid_nome"
        title="Unidade"
        id="unida_codigo"
        url={unidadeUsuario ? 'unidades/usuario' : 'unidades'}
        unique="unid_codigo"
        value={valueUnidade}
        inputValue={inputValueUnidade}
        onChange={(event, newValue) => {
          setValueUnidade(newValue);
        }}
        onInputChange={(event, newInputValueUnidade) => {
          setInputValueUnidade(newInputValueUnidade);
        }}
        disabled={disableUnidade}
        defaultValue=""
        hiddens={[{ name: 'unid_nome' }]}
        getValue={(value) => {
          if (value.unid_codigo !== null) {
            setValueUnidade(value.unid_codigo);
          } else {
            setValueUnidade(0);
          }
        }}

        params={{
          wherefield: 'orga_codigo',
          valuewherefield: valueOrgao,
          typewherefield: 'EQUALS',
        }}
      />

      <Autocomplete
        name="prod_codigo"
        label="prod_descricao"
        title="Produto"
        id="prod_codigo"
        url="produtos"
        unique="prod_codigo"
        value={valueProduto}
        inputValue={inputValueProduto}
        onChange={(event, newValue) => {
          setValueProduto(newValue);
        }}
        onInputChange={(event, newInputValueProtudo) => {
          setInputValueProduto(newInputValueProtudo);
        }}
        defaultValue=""
        hiddens={[{ name: 'prod_descricao' }]}
        getValue={(value) => {
          if (value.prod_codigo !== null) {
            setValueProduto(value.prod_codigo);
          } else {
            setValueProduto(0);
          }
        }}
      />

      <Input name="veic_placa" label="Placa" />

      <Select
        name="abastecimentoagrupamento"
        variant="outlined"
        size="small"
        label="Agrupamento"
        defaultValue="1"
        options={[
          { value: '1', label: 'Listagem' },
          { value: '2', label: 'Placa' },
        ]}
      />

      <RadioGroup
        name="formato"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relabastecimentonoperiodovalor;
